import { Component, ElementRef, Input, ViewChild, Renderer2 } from "@angular/core";
import { FormControl } from "@angular/forms";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { MessageService } from "primeng/api";
import { Subscription, lastValueFrom } from "rxjs";
import { FastAPIService, News } from "src/app/service/fast-api.service";
import { MapService } from "src/app/service/map-page.service";
import Basemap from "@arcgis/core/Basemap";
import Map from "@arcgis/core/Map";
import MapView from "@arcgis/core/views/MapView";
import Graphic from "@arcgis/core/Graphic";
import PictureMarkerSymbol from '@arcgis/core/symbols/PictureMarkerSymbol';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import Point from '@arcgis/core/geometry/Point';
import Extent from "@arcgis/core/geometry/Extent.js";
import { Location } from "@angular/common";
import { formatNumber } from '@angular/common';
import Zoom from '@arcgis/core/widgets/Zoom';
import { WordsegmentComponent } from 'src/app/components/nlp/wordsegment/wordsegment.component';
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer"


@Component({
  selector: 'app-map-page',
  templateUrl: './map-page.component.html',
  styleUrls: ['./map-page.component.scss']
})
export class MapPageComponent {
  @ViewChild(WordsegmentComponent) wordsegmentComponent!: WordsegmentComponent;
  image_path = "assets/search-box-component-images/";
  search_icon_1 = this.image_path + "search-icon-1.svg";
  search_button_icon = this.image_path + "search-button-icon.svg";
  search_button_active_icon = this.image_path + "search-button-active-icon.svg";
  voice_search_button_icon = this.image_path + "voice-search-button-icon.svg";
  line_icon = this.image_path + "line.png";
  cross_icon = this.image_path + "cross-icon.svg";
  search_result_icon = this.image_path + "search-result-guess-icon.svg";
  search_result_focus_icon = this.image_path + "search-result-guess-focus-icon.svg";
  search_history_icon = this.image_path + "search-history-icon.png";
  enter_icon = this.image_path + "enter-icon.svg";
  meta_select_icon = this.image_path + "select.svg";
  meta_open_icon = this.image_path + "open.svg";
  meta_newtab_icon = this.image_path + "openIn.svg";

  main_pin_icon = 'assets/map-page-component-images/mainPin.svg';
  sub_pin_icon = 'assets/map-page-component-images/subPin.svg';
  current_location_icon = 'assets/map-page-component-images/current location.svg';
  list_icon_active = "assets/search-component-images/" + "list_icon_active.svg";
  list_icon_deactive = "assets/search-component-images/" + "list_icon_deactive.svg";
  box_icon_active = "assets/search-component-images/" + "box_icon_active.svg";
  box_icon_deactive = "assets/search-component-images/" + "box_icon_deactive.svg"
  list_icon = this.list_icon_deactive;
  box_icon = "assets/search-component-images/" + "box-icon.svg";
  result_corner_icon = "assets/search-component-images/" + "result-corner-icon.svg";
  view_icon = "assets/search-component-images/" + "view_icon.svg";
  mapPin_icon = "assets/search-component-images/" + "MapPin.svg"

  isLoading: boolean = false;
  showAIBox: boolean = false;
  showlegend: boolean = false;
  notFound: boolean = false;
  showTags: boolean = false;
  isDirectSearch: boolean = false;
  searchQuery: string = '';
  segmentedWords: string[] = [];
  searchHistory: { isAISearch: boolean, input: string,isDirectSearch?: boolean; }[] = [];
  
  scrollLeftt() {
    this.renderer.setProperty(this.slider.nativeElement, 'scrollLeft', this.slider.nativeElement.scrollLeft - 300);
  }
  scrollRight() {
    this.renderer.setProperty(this.slider.nativeElement, 'scrollLeft', this.slider.nativeElement.scrollLeft + 300);
  }


  @ViewChild('mapPanel', { static: true }) mapPanel!: ElementRef;
  map: Map | null = null;
  mapView: MapView | null = null;
  zoomWidget!: Zoom;
  lastZoom!: number;

  showSearchResults = false;
  showCurrentNews = false;
  isAISearch = false;
  isSearch = true;
  isAISearchClick = false;

  currentNews: News | null = null;
  results: News[] = [];

  routerSubscribe: Subscription;
  scrollSubscribe: Subscription | undefined;

  start = 0;
  rows = 20;
  streamDataStr: string = '';
  AISerachExtraConfig: any = '';
  AISerachExtraLayerInfo: any = '';
  isExtraLayerExist: boolean = false;
  streamData: any[] = [];
  resultsFound: number = 0;

  popupCloseFlag: boolean = false;
  
  @Input() source: string | null = null;
  @Input() loading: boolean = true;


  constructor(private route: ActivatedRoute, private router: Router, private fastService: FastAPIService, private location: Location, private mapService: MapService, private messageService: MessageService,private renderer: Renderer2) {
    this.routerSubscribe = this.router.events.subscribe((event) => {
      if(event instanceof NavigationEnd && event.url.split(';')[0] == '/map') {
        this.reloadData();
      }
    })
  }

  ngOnDestroy(): void {
    this.routerSubscribe.unsubscribe();
    this.scrollSubscribe?.unsubscribe();
  }

  ngOnInit(): void {
    const basemap = new Basemap({
      portalItem: {
        id: '28f49811a6974659988fd279de5ce39f'
      }
    });
    this.map = new Map({
      basemap: basemap,
    });
    
    this.mapView = new MapView({
      container: this.mapPanel.nativeElement,
      map: this.map,
      center: [100.523186, 13.736717],
      zoom: 14,
      constraints: {
        minZoom: 2,
        geometry: new Extent({
          xmin: -180,
          ymin: -80,
          xmax: 180,
          ymax: 75
        })
      },
      popup: {
        dockEnabled: false,
        dockOptions: {
          buttonEnabled: false
        },
        viewModel: {
          includeDefaultActions: false,
          actions: []
        }
      },
      popupEnabled: false
    });
    
    this.mapView.ui.move('zoom', 'top-right')
    this.mapView.when(() => {
      this.zoomWidget = new Zoom({
        view: this.mapView as __esri.MapView
      });
  
      this.mapView!.ui.remove('zoom');
      this.mapView!.ui.add(this.zoomWidget, 'top-right');
  
      let isZoomingIn = false;
  
      this.mapView!.watch('zoom', () => {
        const currentZoom = this.mapView!.zoom;
        if (currentZoom > this.lastZoom && !isZoomingIn) {
          isZoomingIn = true;
          this.zoomWidget.destroy();
          this.zoomWidget = new Zoom({
            view: this.mapView as __esri.MapView
          });
          this.mapView!.ui.add(this.zoomWidget, 'top-right');
        } else if (currentZoom < this.lastZoom && isZoomingIn) {
          isZoomingIn = false;
          this.zoomWidget.destroy();
          this.zoomWidget = new Zoom({
            view: this.mapView as __esri.MapView
          });
          this.mapView!.ui.add(this.zoomWidget, 'top-right');
        }
  
        this.lastZoom = currentZoom;
      });
      // this.lastZoom = this.mapView!.zoom;
    });
}
  
  checkScrollEnd(event: any) {
    if(this.loadingSearchNews || this.start >= 20)  return;
    const windowHeight = event.srcElement.clientHeight;
    const documentHeight = event.srcElement.scrollHeight;
    const scrollTop = event.srcElement.scrollTop;

    if (windowHeight + scrollTop >= documentHeight - 100) {
      this.getMoreSearchResults()
    }
  }

  reachTheEnd: boolean = false;
  async getMoreSearchResults() {
    this.loadingSearchNews = true;
    
    await this.fastService.getSearchResult(this.input ?? "*", this.start, this.rows).then((response) => {
      response.newsList = response.newsList.filter(news => {return news.LAT_LON_List})
      if(!response.newsList.length)  {
        this.reachTheEnd = true;
      }
      else {
        for(let news of response.newsList) {
          this.results.push(news);
        }
      }
    })
    this.start += this.rows;

    this.loadingSearchNews = false;
  }
  hovering = false;
  
  async onMousemove(event: MouseEvent) {
    if(this.hovering) return;
    this.isGotonewNews = false;
  }
  
  input: string | null = null;
  currentNews_link: string | null = null;

  mainLatitude: number | null = null;
  mainLongitude: number | null = null;
  mainMarker: PictureMarkerSymbol | null = null;
  subMarker: PictureMarkerSymbol | null = null;
  currentMarker: PictureMarkerSymbol | null = null;
  pin_array: any[] = [];
  subGraphics: Graphic[] = [];
  mainGraphics: Graphic[] = [];
  polylinePaths: any[] = [];
  subClusterFeatureLayer: FeatureLayer = new FeatureLayer;
  mainFeatureLayer: FeatureLayer = new FeatureLayer;
  polylineGraphic: Graphic | null = null;
  mainPoint: Point | null = null;
  findNewsClosestDisableState: boolean = true;
  isGotonewNews: boolean = false;
  highlightSelect: any | null = null;
  search_input: FormControl = new FormControl("");
  
  loadingSearchNews = true;

  clusterPopupOpen: boolean = false;
  
  async reloadData() {
    // this.AISerachExtraConfig.
    this.mapView?.map.removeAll();
    this.mapView?.map.layers.removeAll();
    this.isExtraLayerExist = false
    this.AISerachExtraLayerInfo = ''

    // this.mapView?.goTo()
    
    this.start = 0; 
    this.input = this.route.snapshot.paramMap.get('input');
    this.currentNews_link = this.route.snapshot.paramMap.get('link');
  
    this.loadingSearchNews = true;
    this.results = [];
    this.newsSuggestions = [];

    this.showSearchResults = false;
    this.showCurrentNews = false;
    this.showlegend = false;
    this.notFound = false;

    let paddingLeft = 0;
    let paddingBottom = 0;

    if(this.input || this.currentNews_link) paddingLeft = 600;
  
    if (this.input) {
      this.showSearchResults = true;
      this.showlegend = true;
    }

    if (this.input) {
      this.showTags = this.isDirectSearch;
      this.searchQuery = this.input;
      if (this.wordsegmentComponent) {
        this.wordsegmentComponent.getNlp(this.input);
      }
    } else {
      this.showTags = false;
      this.isDirectSearch = false;
    }

    if (this.input && !this.currentNews_link) {
      if (this.input != "null") {
        this.search_input.setValue(this.input);
      }
      if (!this.currentNews_link) {
        if(this.isSearch){
          this.mapView?.map.removeAll();
          this.mapView?.map.layers.removeAll();
          try{
            const response = await this.fastService.getSearchResult(this.input, this.start, this.rows, 'full', true).then((response) => {
              response.newsList = response.newsList.filter(news => { 
                return news.LAT_LON_List 
              });
              this.reachTheEnd = false;
              this.resultsFound = response.numFound;
              for (let news of response.newsList) {
                this.results.push(news);
              }
              this.start += this.rows;
              if (this.resultsFound === 0) {
                this.notFound = true;
              }
            });
          } catch (error){
            console.error('GetSearchResult error:', error);
          }
            this.streamData = [];
            this.streamDataStr = '';
            this.AISerachExtraConfig = '';
            if (this.isAISearch) {
              try {
                this.showAIBox = false;
                
                this.mapView?.map.removeAll();
                this.mapView?.map.layers.removeAll();


                const [dataStream$, configStream$] = this.fastService.getAISearchResult(this.input);
                dataStream$.subscribe({
                  next: (data: any) => {
                    this.streamDataStr += data.data;
                    this.streamDataStr = this.streamDataStr.split('</>').join(' ');
                  },
                  error: (error: any) => {
                    console.error('Error in streaming:', error);
                  },
                });

                if(this.isAISearchClick){
                  this.showAIBox = true;
                }

                configStream$.subscribe({
                  next: (data: any) => {
                    this.mapView?.graphics.removeAll();
                    this.mapView?.map.layers.removeAll();
                    this.AISerachExtraConfig = data.data; 
                  },
                  error: (error: any) => {
                    console.error('Error in streaming:', error);
                  },
                  complete: () => {
                    this.mapView?.graphics.removeAll();
                    this.mapView?.map.layers.removeAll();
                    if (this.AISerachExtraConfig.isRelateLocationExist){
                      const MockGraphic: Graphic[] = [];
                      const mainMarker = new PictureMarkerSymbol({
                        url: this.main_pin_icon,
                        width: '32px',
                        height: '40px',
                      });

                      
                    
                    if (this.AISerachExtraConfig.isExtraLayerExist){
                      this.isExtraLayerExist = this.AISerachExtraConfig.isExtraLayerExist
                      this.AISerachExtraLayerInfo = "ชั้นข้อมูลที่เกี่ยวข้อง <br>"
                      this.AISerachExtraConfig.ExtraLayers.forEach(async (ExtraLayer: { LayerName: string; LayerType: string; LayerURL: string; }) => {
                        if(ExtraLayer.LayerType == "FeatureLayer"){
                          this.AISerachExtraLayerInfo += ("- " + ExtraLayer.LayerName + "<br>")
                          this.mapView?.map.layers.add(new FeatureLayer({
                            url : ExtraLayer.LayerURL
                          }))
                        }

                        if(ExtraLayer.LayerType == "MapImageLayer"){
                          this.AISerachExtraLayerInfo += ("- " + ExtraLayer.LayerName + "<br>")
                          this.map?.add(new MapImageLayer({
                            url : ExtraLayer.LayerURL
                          }))
                        }
                      });
                    }

                    this.AISerachExtraConfig.Locations.forEach(async (ExtraLocation: { Latitude: number; Longitude: number; Location: string; }) => {
                      MockGraphic.push(
                        new Graphic(
                          {
                            geometry: new Point({
                              latitude: ExtraLocation.Latitude, 
                              longitude: ExtraLocation.Longitude
                            }),
                            symbol: mainMarker,
                            attributes: {
                                Name: ExtraLocation.Location,
                            }
                          }
                        )
                      )

                      this.mapView?.map.layers.add(new GraphicsLayer({graphics: MockGraphic}))
                      await this.mapView?.goTo(MockGraphic)
                    });
                  }
                  }
                });
                
                

                  // // const FloodMap = new MapImageLayer({
                  // //   url:"https://gistdaportal.gistda.or.th/data/rest/services/GFlood/GFlood_Inno_WMS/MapServer",
                  // // })
                  // // this.map?.add(FloodMap)

                  // const AOI01Map = new MapImageLayer({
                  //   url:"https://esrith-bd.cdg.co.th/server/rest/services/AOI01_%E0%B8%AA%E0%B8%99%E0%B8%B2%E0%B8%A1%E0%B8%9A%E0%B8%B4%E0%B8%99%E0%B8%8A%E0%B8%B2%E0%B8%99%E0%B9%80%E0%B8%95_TIF/MapServer",
                  // })
                  // this.map?.add(AOI01Map)
                  // const AOI01_Map = new MapImageLayer({
                  //   url:"https://esrith-bd.cdg.co.th/server/rest/services/%E0%B8%82%E0%B9%89%E0%B8%AD%E0%B8%A1%E0%B8%B9%E0%B8%A5%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%81%E0%B8%9B%E0%B8%A5%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1/MapServer",
                  // })
                  // this.map?.add(AOI01_Map)

                  // const MM_Miliatary_Flight_ShanteLayer = new FeatureLayer({
                  //   url : 'https://esrith-bd.cdg.co.th/server/rest/services/Hosted/MM_Miliatary_Flight_Shante/FeatureServer/0'
                  // })
                  // this.mapView?.map.layers.add(MM_Miliatary_Flight_ShanteLayer)


                  // const FloodAreaLayer = new FeatureLayer({
                  //   url : 'https://gistdaportal.gistda.or.th/data/rest/services/GFlood/GFlood_Inno_WMS/MapServer/1'
                  // })
                  // this.mapView?.map.layers.add(FloodAreaLayer)

                  // const FloodPredictLayer = new FeatureLayer({
                  //   url : 'https://gistdaportal.gistda.or.th/data/rest/services/GFlood/GFlood_Inno_WMS/MapServer/2'
                  // })
                  // this.mapView?.map.layers.add(FloodPredictLayer)
                }
                
                catch (error){
                  console.error('Generate AI Search Map error:', error);
                }
            } else {
              try {
                this.mapView?.graphics.removeAll();
                this.mapView?.map.layers.removeAll();
                const SearchResultPointData = await this.mapService.generatePointsWithOutMainNews(this.results);
                const SearchResultGraphics = this.mapService.createGraphicsFromPointsWithoutMainNews(SearchResultPointData);
                  this.mapView?.map.layers.add(new GraphicsLayer({
                    graphics: SearchResultGraphics,
                  }), 
                  await this.mapView.goTo(SearchResultGraphics)
                )
              }
              catch (error){
                console.error('Generate Normal Search Map error:', error);
              }
            }
          
        }
      }
    }
  
    if (this.currentNews_link) {
      this.fastService.saveHistory(this.currentNews_link, 0).subscribe();
      this.showCurrentNews = true;
      this.showlegend = true;
      
      const response = await this.fastService.searchWithLink(this.currentNews_link);
  
      if (response.Topic_OD != "") {
        this.currentNews = response;
      }
      if (this.currentNews != null) this.currentNews.Detail_OD = this.currentNews?.Detail_OD.split('</>').join(" ");
      await this.getNewsSuggestions();

      if(this.newsSuggestions.length) paddingBottom = 240;
    }

    this.mapViewRefresh(paddingLeft, paddingBottom);

    // if(!this.popupWatch) {
    //   this.popupWatch = reactiveUtils.watch( () => this.mapView?.popup.visible, (visible) => {
    //     if(!visible)  return;

    //     if(!this.mapView?.popup.featureCount) {
    //       this.popupCloseFlag = true;
    //     }
    //   })
    // }

    // if(!this.popupFlagWatch) {
    //   this.popupFlagWatch = reactiveUtils.watch(() => this.popupCloseFlag, (flag) => {
    //     if(flag) {
    //       this.mapView?.closePopup();
    //       this.popupCloseFlag = false;
    //     }
    //   })
    // }

    this.loadingSearchNews = false;
    
    if (this.input != null) {
      if (this.input == "null") {
        this.input = "";
      }
      this.search_input.setValue(this.input);
    } else {
      this.search_input.setValue("");
      this.showSearchResults = false;
    }
  
    if (this.mapView && this.currentNews_link) {
      if (this.currentNews_link) {
        await this.loadMap(true);
      }
    }

    this.mapViewOnEventSetUp()  
  
  }

  mapViewRefresh(paddingLeft: number = this.mapView!.padding.left ? this.mapView!.padding.left : 0, paddingBottom: number = this.mapView!.padding.bottom ? this.mapView!.padding.bottom : 0) {
    const x: MapView = new MapView({
      container: this.mapView!.container,
      map: this.mapView!.map,
      popup: this.mapView!.popup,
      zoom: this.mapView!.zoom,
      constraints: this.mapView!.constraints,
      center: this.mapView!.center,
      ui: this.mapView!.ui,
      graphics: this.mapView!.graphics,
      padding: {left: paddingLeft, bottom: paddingBottom},
      popupEnabled: false
    })

    this.mapView = x;
    this.mapView.when(() => {
      this.zoomWidget.destroy();
      this.zoomWidget = new Zoom({
        view: this.mapView as __esri.MapView
      });
  
      this.mapView!.ui.remove('zoom');
      this.mapView!.ui.add(this.zoomWidget, 'top-right');
  
      let isZoomingIn = false;
  
      this.mapView!.watch('zoom', () => {
        const currentZoom = this.mapView!.zoom;
        const minZoom = this.mapView!.constraints.minZoom;
        const maxZoom = this.mapView!.constraints.maxZoom;
        if (currentZoom > this.lastZoom && !isZoomingIn) {
          isZoomingIn = true;
          this.zoomWidget.destroy();
          this.zoomWidget = new Zoom({
            view: this.mapView as __esri.MapView
          });
          this.mapView!.ui.add(this.zoomWidget, 'top-right');
        } else if (currentZoom < this.lastZoom && isZoomingIn) {
          isZoomingIn = false;
          this.zoomWidget.destroy();
          this.zoomWidget = new Zoom({
            view: this.mapView as __esri.MapView
          });
          this.mapView!.ui.add(this.zoomWidget, 'top-right');
        }
  
        this.lastZoom = currentZoom;
      });
  
      // จำค่าซูมล่าสุดเพื่อใช้ในการตรวจสอบในการ watch
      this.lastZoom = this.mapView!.zoom;
    });
  }

  async mapViewOnEventSetUp() {
    if (this.mapView) { 
      this.mapView.on("mouse-wheel", () => {
        if(this.clusterPopupOpen) {
          this.mapView?.closePopup();
          this.clusterPopupOpen = false;
        }
      })

      let layerView = await this.mapView?.whenLayerView(this.subClusterFeatureLayer);
      this.mapView.on("click", (event) => {
        this.mapView?.hitTest(event).then(async (result: any) => {
          if (result.results.length > 1) {
            const temp = result.results.map((res: any) => res.graphic)
            let feature;
            let flag = true;
            for(let t of temp) {
              if((t.attributes.ObjectID || t.attributes.aggregateId) && t.attributes.isMainNews != "true") {
                feature = t;
                flag = false;
                break;
              }
            }

            if(flag) {
              return;
            }

            // if(feature.attributes.isMainNews == "true") {
            //   this.mapView?.closePopup();
            //   this.clusterPopupOpen = false;
            //   return;
            // }

            if(feature.attributes.ObjectID && feature.attributes.cluster_count == 1) {
              this.clusterPopupOpen = false;
              const query = this.subClusterFeatureLayer.createQuery();
              query.objectIds = [feature.attributes.ObjectID];
              const features = await this.subClusterFeatureLayer.queryFeatures(query);
              let news = features.features[0];
              this.featuresAttributes = [news];
              this.featureIndex = 0;
              this.mapView!.openPopup({
                content: this.createClusterPopupTemplate(),
                location: features?.features?.[0]?.geometry ? new Point(features.features[0].geometry) : undefined,
                title: news.attributes.Topic_OD
              })
              return;
            }

            if(feature.attributes.aggregateId) {
              const aggregateId = feature.attributes.aggregateId;
              let query = layerView.createQuery();
              query.aggregateIds = [aggregateId];
              const objectIDs = await layerView.queryObjectIds(query);
              query = this.subClusterFeatureLayer.createQuery();
              query.objectIds = objectIDs;
              let features = await this.subClusterFeatureLayer.queryFeatures(query);

              let lastTopic = "";
              this.featuresAttributes = [];
              this.featureIndex = 0;
              for(let feature of features.features) {
                let attributes = feature.attributes;
                if(attributes.Topic_OD == lastTopic) {
                  continue;
                }
                else {
                  lastTopic = attributes.Topic_OD;
                  this.featuresAttributes.push(feature);
                }
              }
              this.mapView!.openPopup({
                content: this.createClusterPopupTemplate(),
                location: feature.geometry,
                updateLocationEnabled: true,
                title: this.featuresAttributes[this.featureIndex].attributes.Topic_OD
              })
              this.clusterPopupOpen = true;
              return;
            }

            
          }
          else {
            this.clusterPopupOpen = false;
            this.mapView?.closePopup();
          }
        })
      })
    }
  }

  // createPopupTemplate(feature: Graphic): HTMLElement {
  //   const main = document.createElement("div");
  //   main.style.display = "flex";
  //   main.style.flexDirection = "column";
  //   main.style.gap = "10px"
  //   main.style.justifyContent = "center"
  
  //   const img = document.createElement("img");
  //   img.src = feature.attributes.Picture_URL_OD;
  //   img.style.padding = "0"
  //   img.style.boxShadow = "0px 2px 20px 0px #121B211A"
  //   img.style.objectFit = "cover";
  //   img.style.width = "80%";
  //   img.style.height = "150px"
  //   img.style.borderRadius = "10px";
  //   img.style.alignSelf = "center"
    
  //   main.appendChild(img);

  //   const div = document.createElement("div");
  //   div.style.display = "flex";
  //   div.style.justifyContent = "space-between"
  //   div.style.alignItems = "center";
  //   div.style.padding = "3px 15px"
  //   div.style.boxShadow = "0px 2px 20px 0px #121B211A"
  //   const a = document.createElement("button");
  //   a.textContent = "อ่านต่อ >>"
  //   a.onclick = () => {
  //     if (this.input) {
  //       this.router.navigate(['map', {input: this.input, link: feature.attributes.Link_OD}]);
  //     } else {
  //       this.router.navigate(['map', {link: feature.attributes.Link_OD}]);
  //     }
  //     this.mapView?.closePopup();
  //   }
  //   a.style.color = "white";
  //   a.style.fontSize = "16px"
  //   a.style.fontWeight = "bold";
  //   a.style.borderRadius = "16px";
  //   a.style.padding = "10px"
  //   a.style.margin = "0"
  //   a.style.border = "none";
  //   a.style.background = "dodgerblue"

  //   const divPosition = document.createElement("div");
  //   divPosition.style.display = "flex";
  //   divPosition.style.flexDirection = "column";
  //   divPosition.style.fontSize = "20px";
  //   divPosition.style.gap = "5px"
  //   divPosition.style.margin = "0";
  //   divPosition.style.padding = "0";
  //   const pLat = document.createElement("p");
  //   const pLon = document.createElement("p");
  //   pLat.textContent = "Latitude:  " + feature.attributes.latitude;
  //   pLon.textContent = "Longitude: " + feature.attributes.longitude;
  //   pLat.style.fontSize = "large";
  //   pLon.style.fontSize = "large";
  //   pLat.style.margin = "0";

  //   divPosition.appendChild(pLat)
  //   divPosition.appendChild(pLon);
  //   div.appendChild(divPosition)
  //   div.appendChild(a)

  //   main.appendChild(div)

  //   return main;
  // }

  featuresAttributes: any[] = [];
  featureIndex: number = 0;
  createClusterPopupTemplate(): HTMLElement {
    const mainContainer = document.createElement("div");
    mainContainer.className = "popup-main-container";

    const attributes = this.featuresAttributes[this.featureIndex].attributes;
    const featureContainer = document.createElement("div");
    featureContainer.className = "popup-feature-container"

    const img = document.createElement("img");
    img.className = "popup-feature-image"
    img.src = attributes.Picture_URL_OD;

    const div = document.createElement("div");
    div.className = "popup-feature-data-and-button-container"

    const data = document.createElement("div");
    data.className = "popup-feature-data";


    const pLocation = document.createElement("p");
    pLocation.textContent = "พิกัด " + formatNumber(attributes.latitude, "en-US", '1.0-3') + ", " + formatNumber(attributes.longitude, "en-US", '1.0-3');

    data.appendChild(pLocation);
      
    const a = document.createElement("button");
    a.className = "popup-feature-button"
    a.textContent = "อ่านต่อ >>"
    a.onclick = () => {
      if (this.input) {
      this.router.navigate(['map', {input: this.input, link: attributes.Link_OD}]);
      } else {
        this.router.navigate(['map', {link: attributes.Link_OD}]);
      }
      this.mapView?.closePopup();
    }

    div.append(data)
    div.appendChild(a);

    featureContainer.appendChild(img)
    featureContainer.appendChild(div);

    const navigationContainer = document.createElement("div");
    navigationContainer.className = "popup-feature-navigation-container";

    const back_btn = document.createElement('button');
    back_btn.className = "feature-navigate-button pi pi-caret-left";
    back_btn.disabled = this.featureIndex <= 0
    back_btn.onclick = () => {
      this.featureIndex = this.featureIndex - 1;
    
      const popup = this.mapView?.popup;
      const feature = this.featuresAttributes?.[this.featureIndex]?.attributes;
    
      if (popup && feature) {
        popup.content = this.createClusterPopupTemplate() || null;
        popup.title = feature.Topic_OD || 'Untitled';
      } else {
        console.warn('Cannot update popup: mapView or features missing');
      }
    };

    const next_btn = document.createElement('button');
    next_btn.className = "feature-navigate-button pi pi-caret-right";
    next_btn.disabled = this.featureIndex >= this.featuresAttributes.length - 1;
    
    next_btn.onclick = () => {
      this.featureIndex = this.featureIndex + 1;
    
      const popup = this.mapView?.popup;
      const feature = this.featuresAttributes?.[this.featureIndex]?.attributes;
    
      if (popup && feature) {
        popup.content = this.createClusterPopupTemplate() || null;
        popup.title = feature.Topic_OD || 'Untitled';
      } else {
        console.warn('Cannot update popup: mapView or features missing');
      }
    };

    const page = document.createElement('h3');
    page.className = "popup-feature-navigation-page";
    page.textContent = (this.featureIndex + 1) + "/" + (this.featuresAttributes.length);

    navigationContainer.appendChild(back_btn);
    navigationContainer.appendChild(page);
    navigationContainer.appendChild(next_btn);

    mainContainer.appendChild(featureContainer);
    if(this.featuresAttributes.length > 1)  mainContainer.appendChild(navigationContainer);

    return mainContainer;
  }
  
  async loadMap(gotoMain: boolean) {
    this.isGotonewNews = true;
    this.mainMarker = new PictureMarkerSymbol({
      url: this.main_pin_icon,
      width: '32px',
      height: '40px',
    });

    this.subMarker = new PictureMarkerSymbol({
      url: this.sub_pin_icon,
      width: '22px',
      height: '30px',
    });

    this.currentMarker = new PictureMarkerSymbol({
      url: this.current_location_icon,
      width: '40px',
      height: '40px'
    })

    this.pin_array = [];
    this.pin_array.push(this.currentNews)
    const mainPointData = await this.mapService.generatePoints(this.pin_array,this.currentNews);
    this.mainGraphics = this.mapService.createMainGraphicsFromPoints(mainPointData);

    if (mainPointData.length == 1) {
      this.mainLatitude = mainPointData[0].latitude;
      this.mainLongitude = mainPointData[0].longitude;
    }

    if (mainPointData.length == 0) {
      this.findNewsClosestDisableState = true;
    } else {
      this.findNewsClosestDisableState = false;
    }

    this.polylinePaths = await this.mapService.getPolylinePath(this.mainGraphics);
    this.mainFeatureLayer = await this.mapService.getFeatureLayer(this.mainGraphics, this.mainMarker);

    this.pin_array = [];
    this.subClusterFeatureLayer = new FeatureLayer();
    if (this.newsSuggestions.length > 0) {
      this.newsSuggestions.forEach((i) => {
        this.pin_array.push(i)
      })
  
      const subPointsData = await this.mapService.generatePointsWithOutMainNews(this.pin_array);
      this.subGraphics = this.mapService.createGraphicsFromPointsWithoutMainNews(subPointsData);
  
      this.subClusterFeatureLayer = await this.mapService.getFeatureLayer(this.subGraphics, this.subMarker);
    }

    if (this.mapView) {
      if (this.subClusterFeatureLayer.source) {
        this.mapService.generateClusterConfig(this.subClusterFeatureLayer, this.mapView).then((featureReduction) => {
          this.subClusterFeatureLayer.featureReduction = featureReduction as __esri.FeatureReductionCluster
          this.subClusterFeatureLayer.featureReduction.clusterRadius = 80;
        }).catch((error) => {
          console.log(error)
        })
      }
    }

    if (this.mapView) {
      await this.mapService.updateMapView(this.mapView, this.subClusterFeatureLayer, this.polylinePaths, this.mainGraphics)

      this.mapView.when(() => {
        if (this.mainGraphics && gotoMain) {
          this.mapService.goToMainGraphic(this.mainGraphics, this.mapView, this.mainLatitude, this.mainLongitude)
        }
      }) 
    }
  }

  async findClosestNews() {
    if (this.currentNews?.Location_List) {
      this.isLoading = true;
      const location_list = this.currentNews.Location_List;
      const closest_news_result:any[] = [];
      const promises = location_list.map(async (i: any) => {
        const res = (await this.fastService.getSearchResult(i, 0, 5)).newsList;
        const filter_res = res.filter((doc: News) => {
          return doc.LAT_LON_List;
        });
        filter_res.forEach((i: any) => {
          closest_news_result.push(i);
        });
      });
      
      await Promise.all(promises);
      
      const closest_news_result_filter = closest_news_result.filter((news) => {
        return news.Topic_OD != this.currentNews?.Topic_OD
      })

      this.newsSuggestions = [];
      closest_news_result_filter.forEach((i:any) => {
        this.newsSuggestions.push(i)
      })

      for (let result of this.newsSuggestions) {
        result.icon = await this.fastService.getFavicon(result.Link_OD);
        result.Detail_OD = result.Detail_OD.split('</>').join(' ');
      }

      this.pin_array = [];
      this.newsSuggestions.forEach((i) => {
        this.pin_array.push(i)
      })

      const pointsData = await this.mapService.generatePointsWithOutMainNews(this.pin_array);
      this.subGraphics = this.mapService.createGraphicsFromPointsWithoutMainNews(pointsData);

      if (this.subMarker) {
        this.subClusterFeatureLayer = await this.mapService.getFeatureLayer(this.subGraphics, this.subMarker);
      }
      
      if (this.mainMarker) {
        this.mainFeatureLayer = await this.mapService.getFeatureLayer(this.mainGraphics, this.mainMarker);
      }

      if (this.mapView) {

        await this.mapService.updateMapView(this.mapView, this.subClusterFeatureLayer, this.polylinePaths, this.mainGraphics)
        
        this.mapView.when(() => {
          this.mapView?.goTo({
            center: this.mainGraphics?? this.subGraphics,
            time: 1000
          });
        })
      }
      this.isLoading = false;
    } else {
      this.messageService.add({ severity: 'warn', summary: 'Warn', detail: 'ข่าวที่ท่านสนใจไม่มี Location' });
      this.isLoading = false;
    }
  }

  async findCurrentLocation() {
    this.isLoading = true;
    this.findNewsClosestDisableState = true;
    if (this.newsSuggestions) {
      this.mapView!.padding.bottom = 240;
    } else {
      this.mapView!.padding.bottom = 0;
    }
    navigator.geolocation.getCurrentPosition(async resp => {
      const coorMap = {
        latitude: resp.coords.latitude,
        longitude: resp.coords.longitude
      }
      const coor = new Point({
        latitude: resp.coords.latitude,
        longitude: resp.coords.longitude
      });
      
      try {
        const location = await lastValueFrom(this.fastService.getNewsByLatLon(coorMap, 6));
        
        if (!this.currentMarker || !this.subMarker) {
          this.currentMarker = new PictureMarkerSymbol({
            url: this.current_location_icon,
            width: '40px',
            height: '40px'
          });
        
          this.subMarker = new PictureMarkerSymbol({
            url: this.sub_pin_icon,
            width: '22px',
            height: '30px'
          });
        }
  
        if (this.currentMarker) {
          const currentLocationGraphic = new Graphic({
            geometry: coor,
            symbol: this.currentMarker
          });
          this.mainGraphics = [];
          this.mainGraphics.push(currentLocationGraphic);
    
          this.newsSuggestions = [];
          for (let i of location.response) {
            this.newsSuggestions.push(i);
          }
  
          for (let result of this.newsSuggestions) {
            result.icon = await this.fastService.getFavicon(result.Link_OD);
            result.Detail_OD = result.Detail_OD.split('</>').join(' ');
          }
  
          this.pin_array = [];
          for (let i of this.newsSuggestions) {
            this.pin_array.push(i);
          }
  
          const pointsData = await this.mapService.generatePoints(this.pin_array, "");
          this.subGraphics = this.mapService.createGraphicsFromPoints(pointsData);
  
          this.subClusterFeatureLayer = await this.mapService.getFeatureLayer(this.subGraphics, this.subMarker);
  
          if (this.mapView) {
            this.mapView.graphics.removeAll();
            this.mapView.map.layers.removeAll();
  
            if (this.subClusterFeatureLayer) {
              this.mapView.map.layers.add(this.subClusterFeatureLayer);
              this.mapView.map.reorder(this.subClusterFeatureLayer, this.mapView.map.layers.length);
            }           
          }
  
          this.mainPoint = coor;
          this.mapView?.graphics.add(currentLocationGraphic);
    
          this.mainLatitude = coor.latitude ?? null;;
          this.mainLongitude = coor.longitude ?? null;;
          
          this.mapView?.when(() => {
            this.mapView?.goTo({
              center: [this.mainLongitude ?? 100.523186, this.mainLatitude ?? 13.736717], // If null go to Bangkok location
              zoom: 11,
              time: 1000
            });
          });
        }
        this.currentNews = location.response[0];
        this.isLoading = false;
      } catch(err) {
        this.messageService.add({ severity: 'warn', summary: 'Warn', detail: 'Current location ไม่พร้อมใช้งานในขณะนี้' });
        this.isLoading = false;
      }
      
    },
    err => {
      this.messageService.add({ severity: 'warn', summary: 'Warn', detail: 'ไม่สามารถค้นหาตำแหน่งปัจจุบันได้' });
      this.isLoading = false;
    });
  }

  preventTab(e: KeyboardEvent) {
    if (e.key === "Tab") {
      e.preventDefault()
    }
  }

  onClearClick(event: MouseEvent){
    event.preventDefault();
    this.search_input.setValue("");
  }

  onPinClick(link:string) {
    if (this.input) {
      this.router.navigateByUrl('/map;input=' + this.input +';link=' + encodeURIComponent(link));
    } else {
      this.router.navigateByUrl('/map;link=' + encodeURIComponent(link));
    }
  }

  onSegmentedWordsChange(words: string[]) {
    this.segmentedWords = words;
  }

  onSearchClick(search_input: string) {
    this.isAISearch = false; 
    this.isSearch = true;
    this.showAIBox = false;
    this.currentNews = null;
    this.searchQuery = search_input;  
    this.showTags = true;  
    this.isDirectSearch = true;
    this.searchHistory.push({ isAISearch: false, input: search_input, isDirectSearch: true });
    this.router.navigate(['map', {input: search_input}])
    .then(() => {
      this.isAISearch = false;
      this.isSearch = true;
      this.reloadData()
    });
  }

  onSearchAIClick(input: string | null){
    this.isAISearch = false;
    this.isSearch = false;
    this.currentNews = null;
    this.results = []; 
    this.showSearchResults = false; 
    this.searchHistory.push({ isAISearch: true,  input: input || '' });
    this.router.navigate(['map', { input: input }])
    .then(() => {
      this.isAISearch = true;
      this.isSearch = true;
      this.isAISearchClick = true;
      this.reloadData().then(() => {
        this.showSearchResults = true; 
      })
      this.showAIBox = false;
    });
}

  onMouseLeave() {
    if (this.highlightSelect) {
      this.highlightSelect.remove()
    }
    this.mapService.goToMainGraphic(this.mainGraphics, this.mapView, this.mainLatitude, this.mainLongitude)
  }

  onMouseOver(suggestion:any) {
    if (suggestion.LAT_LON_List) {
      if (!this.isGotonewNews) {
        const lat_lon = suggestion.LAT_LON_List[0].split(',');
        const latitude = lat_lon[0];
        const longitude = lat_lon[1];
        const pointTogoto = new Point({
          latitude: latitude,
          longitude: longitude
        })

        this.mapView?.goTo({
          center: pointTogoto,
          zoom: 10,
          duration: 2000
        }).then(() => {
          this.mapView?.whenLayerView(this.subClusterFeatureLayer).then((layerView) => {
            const sourceSub:any = this.subClusterFeatureLayer.source
            const filterSub = sourceSub.items.filter((i:any) => {
              return i.attributes.Topic_OD == suggestion.Topic_OD
            })
  
            const query = this.subClusterFeatureLayer.createQuery();
            const objectID = filterSub[0].attributes.ObjectID
            query.where = "ObjectID = '" + objectID + "'"; 
            
            layerView.queryFeatures(query).then((result) => {
              if (result.features.length > 0) {
                if (this.highlightSelect) {
                  this.highlightSelect.remove();
                }
                this.highlightSelect = layerView.highlight(result.features[0]);
              } else {
                return
              }
            });
          });
        })
      }  
    }
  }
  
  onResultClick(result: News) {
    const wasAISearch = this.isAISearch;
    this.showAIBox = false;
    this.showTags = true;
    this.isDirectSearch = true;

    if (this.input) {
        this.router.navigate(['map', { input: this.input, link: result.Link_OD }]);
    } else {
        this.router.navigate(['map', { link: result.Link_OD }]);
    }
    this.searchHistory.push({
        isAISearch: wasAISearch,
        input: this.input || '',
        isDirectSearch: true
    });
}

  getFormatViews(views: number = 0) {
    if(views < 1000)  return views;
    else  {
      let temp = Math.ceil(views / 100);
      return temp / 10;
    }
  }

  getPublishDate(): number | null {
  const timestamp = Number(this.currentNews?.PublishDate_OD);
  return isNaN(timestamp) ? null : timestamp * 1000;
  }


  goBack() {
    this.currentNews = null;
    this.newsSuggestions = [];
    this.mapViewRefresh(0);
    this.showAIBox = false;
  
    if (this.searchHistory.length > 1) {
      this.searchHistory.pop();
      const previousSearch = this.searchHistory[this.searchHistory.length - 1];
      this.isAISearch = previousSearch.isAISearch;
      if (this.isAISearch) {
        this.isAISearchClick = true;
      }
      this.input = previousSearch.input;
      this.showSearchResults = true;
      this.showCurrentNews = false;
      this.showTags = previousSearch.isDirectSearch ?? false;
      this.isDirectSearch = previousSearch.isDirectSearch ?? false;
    } else {
      this.isAISearch = false;
      this.showAIBox = false;
      this.input = null;
      this.showSearchResults = false;
      this.showCurrentNews = false;
      this.showTags = false;
      this.isDirectSearch = false;
    }
    
    this.location.back();
  }
         

  onNewsSuggestionClick(news: News): any {
    const wasAISearch = this.isAISearch;
    this.showTags = false;
    this.isDirectSearch = false; 
   
    if(this.isMove) return;
    this.currentNews = news;
    this.mapView?.closePopup();

    this.mapViewRefresh(0);

    if (this.input) {
      this.router.navigate(['map', {input: this.input, link: news.Link_OD}]);
    } else {
      this.router.navigate(['map', {link: news.Link_OD}]);
    }

    this.searchHistory.push({
      isAISearch: wasAISearch,
      input: this.input || '',
      isDirectSearch: false
  });
  }

  newsSuggestions: News[] = [];
  async getNewsSuggestions() {
    if(this.currentNews?.Topic_OD.length) this.newsSuggestions = (await this.fastService.getSearchResult(this.currentNews.Topic_OD, 0, this.rows, "example")).newsList.filter(news => {return news.LAT_LON_List});
  }

  @ViewChild('slider') slider!: ElementRef;
  mouseDown = false;
  startX: any;
  scrollLeft: any;
  isMove = false;
  startDragging(e: MouseEvent) {
    this.mouseDown = true;
    this.isMove = false;
    this.startX = e.pageX - this.slider.nativeElement.offsetLeft;
    this.scrollLeft = this.slider.nativeElement.scrollLeft;
  }
  stopDragging(e: MouseEvent) {
    this.mouseDown = false;
  }
  moveEvent(e: MouseEvent) {
    e.preventDefault();
    if (!this.mouseDown) {
      return;
    }
    this.isMove = true;
    const x = e.pageX - this.slider.nativeElement.offsetLeft;
    const scroll = x - this.startX;
    this.slider.nativeElement.scrollLeft = this.scrollLeft - scroll;
  }
  
  async toggleSearchContainer() {
    await this.mapView?.closePopup();
    if (this.showCurrentNews || this.showSearchResults) {
        this.showCurrentNews = false;
        this.showSearchResults = false;
        
        
        if (!this.showSearchResults && !this.showCurrentNews) {
            this.showAIBox = false;
        }

        if (this.mapView) {
          this.mapViewRefresh(0);
        }
    } else {
      this.showlegend = true;
        if (this.currentNews_link) {
            this.showCurrentNews = true;
        }
        if (this.input) {
            this.showSearchResults = true;
            if (this.isAISearch) {
              this.showAIBox = true;
            }
        }
        if (this.mapView) {
          this.mapViewRefresh(600)
        }
      }

      this.mapViewOnEventSetUp();
    }
  }
